export default __webpack_public_path__ + "static/media/Broadform-building-insurance-policy-2025.5e5e1b55.pdf";